export default __webpack_public_path__ + "static/media/insightdata_consulter.4f8a844f.svg";